import React from "react";
import { Icon, Text } from "@mbank-design/design-system/components";
import {
  ArrowDown,
  ArrowRight,
  ClipboardListColor,
  EmailSignColor,
  PaperTickColor,
} from "@mbank-design/design-system/icons";

import "./index.scss"
import { useMobileOnlyMedia } from "@mbank-design/design-system/components/Media/useMobileOnlyMedia";

const RequestModalSteps = () => {
  const isMobile = useMobileOnlyMedia();

  return (
    <div className="request-modal-steps">
      <div className="request-modal-steps__step">
        <Icon iconComponent={ClipboardListColor}></Icon>
        <Text>wypełnij formularz</Text>
      </div>
      <Icon iconComponent={isMobile ? ArrowDown : ArrowRight}></Icon>

      <div className="request-modal-steps__step">
        <Icon iconComponent={EmailSignColor}></Icon>
        <Text>sprawdź e-mail i zaakceptuj ofertę</Text>
      </div>
      <Icon iconComponent={isMobile ? ArrowDown : ArrowRight}></Icon>
      <div className="request-modal-steps__step">
        <Icon iconComponent={PaperTickColor}></Icon>
        <Text>złóż wniosek i podpisz umowę</Text>
      </div>
    </div>
  );
};

export default RequestModalSteps;
